
import About from "./components/About";
import Card from "./components/Card";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar"
import Product from "./components/Product";
import ImageSlider from "./components/Imageslider";
import OurTeam from "./components/Ourteam";
import Footer from "./components/Footer";
import Achivment from "./components/Achivment";
import Meetclient from "./components/Meetclient";
import FixedLottieAnimation from "./components/Lottiewa";
import Example from "./components/Lottiewa";
import Ourteam2 from "./components/Ourteam2";
import Footer2 from "./components/Footer2";



function App() {
  return (
     <div> 
    <Navbar />
   
    <ImageSlider />
    <Hero/>
    <About />
    <Card />
   <Product />
   {/* <OurTeam /> */}
   <Ourteam2 />
   <Achivment />
   <Meetclient />
   {/* <Footer /> */}
   <Footer2 />
   <Example />
    


    </div>
  );
}

export default App;
